/** Full-page loader — the React equivalent of `#WaitLoaderGo`. */
export function PageLoader() {
  return (
    <div className="loader-overlay">
      <div className="loader" />
    </div>
  )
}

export function InlineLoader({ label = 'Loading…' }: { label?: string }) {
  return <div className="inline-loader">{label}</div>
}

export function EmptyState({ message }: { message: string }) {
  return <div className="empty-state">{message}</div>
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="alert alert-error">
      {message}
      {onRetry && (
        <>
          {' '}
          <button type="button" className="link-btn" onClick={onRetry}>Retry</button>
        </>
      )}
    </div>
  )
}
